export default __webpack_public_path__ + "static/media/squared.51e1f1ba.svg";